import React from 'react';
import { Card, Typography, Row, Col } from 'antd';
import { FireOutlined } from '@ant-design/icons';
import styled from 'styled-components';

const { Title, Text } = Typography;

const StyledCard = styled(Card)`
  .streak-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
  .streak-icon {
    font-size: 48px;
    color: #ff4d4f;
    margin-bottom: 16px;
    animation: flicker 2s infinite;
  }
  @keyframes flicker {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.8; }
  }
  .streak-number {
    font-size: 48px;
    font-weight: 700;
    background: linear-gradient(135deg, #ff6b6b 0%, #ff4d4f 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    line-height: 1;
    margin-bottom: 8px;
  }
  .streak-stats {
    margin-top: 20px;
    padding-top: 20px;
    border-top: 1px solid #f0f0f0;
  }
`;

interface StreakTrackerProps {
  currentStreak: number;
  longestStreak: number;
  loading?: boolean;
}

const StreakTracker: React.FC<StreakTrackerProps> = ({
  currentStreak,
  longestStreak,
  loading = false
}) => {
  return (
    <StyledCard bordered={false} loading={loading}>
      <div className="streak-container">
        <div className="streak-icon">
          <FireOutlined />
        </div>
        <div className="streak-number">{currentStreak}</div>
        <Title level={4} style={{ margin: 0 }}>Day Streak</Title>
        <Text type="secondary">Keep it going!</Text>
      </div>

      <div className="streak-stats">
        <Row gutter={16}>
          <Col span={12} style={{ textAlign: 'center' }}>
            <Title level={4} style={{ margin: 0 }}>{currentStreak}</Title>
            <Text type="secondary">Current</Text>
          </Col>
          <Col span={12} style={{ textAlign: 'center', borderLeft: '1px solid #f0f0f0' }}>
            <Title level={4} style={{ margin: 0 }}>{longestStreak}</Title>
            <Text type="secondary">Best</Text>
          </Col>
        </Row>
      </div>
    </StyledCard>
  );
};

export default StreakTracker;
